export default "__VITE_ASSET__953764a7__"